<script>
  export let content = "";
  import { getContext } from "svelte";
  const { getParent } = getContext("accordion");

  const id = Math.random().toString(36).slice(2, 9);
</script>

<div class="accordion-item border-bottom">
  <h2 class="accordion-header">
    <button
      class="accordion-button collapsed"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target={`#${getParent()}-${id}`}
      aria-expanded="false"
      aria-controls={`${getParent()}`}
    >
      <slot name="header" />
    </button>
  </h2>
  <div
    id={`${getParent()}-${id}`}
    class="accordion-collapse collapse"
    data-bs-parent={`#${getParent()}`}
  >
    <div class="accordion-body bg-body-tertiary" bind:this={content}>
      <slot name="content" />
    </div>
  </div>
</div>
